import { ApplicationInsights, SeverityLevel } from "@microsoft/applicationinsights-web";
export const AppInsightsConnectionStringKey = "ai_connection_string";
class AppInsights {
    private appInsights: ApplicationInsights | null = null;
    constructor() {
        this.InitializeAppInsights();
    }

    public TrackExcepton(message: string) {
        if (this.appInsights?.core.isInitialized) {
            this.appInsights.trackException({ exception: new Error(message), severityLevel: SeverityLevel.Warning, properties: { Toast: "Error" } });
        }
    }

    private InitializeAppInsights() {
        const cookies = this.getCookies();

        const appInsightsConnectionString = cookies[AppInsightsConnectionStringKey];
        if (!appInsightsConnectionString) {
            return;
        }

        const enabledUserTracking = cookies["cookieconsent_status"] === "allow";

        const ai = new ApplicationInsights({
            config: {
                connectionString: appInsightsConnectionString,
                disableCookiesUsage: !enabledUserTracking,
                isStorageUseDisabled: !enabledUserTracking,
                disablePageUnloadEvents: [ "unload" ],
                disableUserInitMessage: true
            }
        })
        ai.loadAppInsights();
        ai.trackPageView();
        this.appInsights = ai;
    }

    private getCookies() {
        const cookies: { [key: string]: string } = {};
        for (const cookie of document.cookie.split("; ")) {
            const [name, value] = cookie.split("=");
            cookies[name] = decodeURIComponent(value);
        }
        return cookies;
    }
}
export default new AppInsights();
